import { DatePipe } from '@angular/common';

/**
 * Classe utilitaire sur les dates
 * 
 */
export class CcdDateUtils {

    /**
     * Donne un objet date à partier d'une string en AAAAMMJJ
     */
    static getDateFromAAAAMMJJ(sDateAAAAMMJJ : string) : Date {
        let year = Number.parseInt(sDateAAAAMMJJ.substring(0, 4));
        let month = Number.parseInt(sDateAAAAMMJJ.substring(4, 6));
        let day = Number.parseInt(sDateAAAAMMJJ.substring(6, 8));
        let date : Date = new Date(year, month - 1, day);
        return date;
    }

    /**
     * Donne le libellé en francais du mois à partir d'une date
     * @param date 
     */
    static getLibelleMois(date : Date) : string {
        let datePipe: DatePipe = new DatePipe('fr-FR');
        let result : string =  datePipe.transform(date, 'MMMM');
        return result;
    }

    /**
     * Donne le libéllé du mois et l'année à partir d'une date
     * @param date 
     */
    static getLibelleMoisEtAnnee(date : Date) : string {
        let datePipe: DatePipe = new DatePipe('fr-FR');
        let result : string =  datePipe.transform(date, 'MMMM yyyy');
        return result;
    }

    /**
     * Donne une nouvelle date en fonction de celle passée en 
     * paramètre en ajoutant des mois (sans modifier celle passée en paramètre)
     * 
     * @param date 
     * @param aAjouter nombre positif ou négatif
     */
    static getDateAvecMoisSupplementaire(date : Date, aAjouter : number) : Date {
        let result : Date = new Date(date);
        result.setMonth(date.getMonth() + aAjouter);
        return result;
    }
}
